<template>
  <div id="app">
    <nav v-if="showNav">
      <router-link to="/">🏠</router-link>
      <div class="nav-right">
        <div v-if="totalStars > 0" class="nav-stars" :key="totalStars">
          <span class="nav-star-icon">⭐</span>
          <span class="nav-star-count">{{ totalStars }}</span>
        </div>
        <div v-if="userName" class="nav-profile">
          <img v-if="userAvatar" :src="userAvatar" class="nav-avatar" />
          <span class="nav-name">{{ userName }}</span>
        </div>
      </div>
    </nav>
    <main>
      <router-view />
    </main>
  </div>
</template>

<script setup>
import { computed, onMounted } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useUserProfile } from './composables/useUserProfile.js'

const route = useRoute()
const router = useRouter()
const { isProfileComplete, userName, userAvatar, totalStars } = useUserProfile()

const showNav = computed(() => route.path !== '/' && route.path !== '/welcome')

onMounted(() => {
  if (!isProfileComplete() && route.path !== '/welcome') {
    router.replace('/welcome')
  }
})
</script>

<style>
@import url('https://fonts.googleapis.com/css2?family=Nunito:wght@400;700;900&display=swap');

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: 'Nunito', sans-serif;
  background: #fafafa;
  color: #2c3e50;
  -webkit-tap-highlight-color: transparent;
  user-select: none;
}

#app {
  min-height: 100vh;
  padding: 16px;
}

nav {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 8px;
}

nav a {
  font-size: 28px;
  text-decoration: none;
}

.nav-right {
  display: flex;
  align-items: center;
  gap: 12px;
}

.nav-stars {
  display: flex;
  align-items: center;
  gap: 4px;
  background: linear-gradient(135deg, #fff9c4, #fff176);
  padding: 4px 12px;
  border-radius: 20px;
  box-shadow: 0 2px 8px rgba(255, 193, 7, 0.3);
  animation: starsPop 0.4s ease;
}

.nav-star-icon {
  font-size: 18px;
  animation: starSpin 1.5s ease infinite;
}

.nav-star-count {
  font-size: 16px;
  font-weight: 900;
  color: #e65100;
  min-width: 16px;
  text-align: center;
}

@keyframes starsPop {
  0% { transform: scale(0); opacity: 0; }
  60% { transform: scale(1.2); }
  100% { transform: scale(1); opacity: 1; }
}

@keyframes starSpin {
  0%, 100% { transform: rotate(0deg) scale(1); }
  25% { transform: rotate(15deg) scale(1.1); }
  75% { transform: rotate(-15deg) scale(1.1); }
}

.nav-profile {
  display: flex;
  align-items: center;
  gap: 8px;
}

.nav-avatar {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  object-fit: cover;
  border: 2px solid #e0e0e0;
}

.nav-name {
  font-size: 16px;
  font-weight: 700;
  color: #2c3e50;
}

main {
  max-width: 800px;
  margin: 0 auto;
  padding: 0 8px;
}

button {
  font-family: 'Nunito', sans-serif;
}
</style>
